

import Button from './common/Button.vue';
import Swiper from './common/Swiper.vue';
import { reachGoal } from './utils/metrika.js';

export default {
    name: 'MeatPageHero',
    components: { Button, Swiper },
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        common: {
            type: Object,
            default: () => ({})
        }
    },
    methods: { reachGoal }
}
